import { orderBy } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { isUndefined } from 'webpack-merge/dist/utils';
import Ripple from '../../utils/Ripple';
import SpinnerError from '../../utils/SpinnerError';
import SelectBox, { RETURN_TYPE, } from '../base/SelectBox';
import useApplyFilter from './hooks/useApplyFilter';
export default function SelectBoxFilter({ itemValuePropName = 'value', itemTitlePropName = 'name', orderOptionsBy, academicYearsGroups = [], disabled = false, hasLiveSearch = false, loading = false, error = null, returnType = RETURN_TYPE.STRING, includeAll, allOptions, placeholder, options, value, onChange, ...rest }) {
    const optionsList = useMemo(() => (orderOptionsBy ? orderBy(options, orderOptionsBy) : options), [options, orderOptionsBy]);
    const { applyFilters } = useApplyFilter();
    useEffect(() => {
        if (onChange && isUndefined(value) && (optionsList === null || optionsList === void 0 ? void 0 : optionsList.length) === 1) {
            onChange(returnType === RETURN_TYPE.OPTION
                ? optionsList[0]
                : optionsList[0][itemValuePropName]);
            requestAnimationFrame(() => {
                applyFilters && applyFilters();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applyFilters, onChange, optionsList]);
    return (<Ripple>
      <SpinnerError error={error} inline={false} loading={loading}>
        <SelectBox hasGroupNameInTitle isFilterBar withTitle disabled={disabled} groupTitleKeys={academicYearsGroups} itemTitlePropName={itemTitlePropName} itemValuePropName={itemValuePropName} liveSearch={hasLiveSearch} loading={loading} options={optionsList} orderOptionsBy={orderOptionsBy} placeholder={includeAll ? allOptions === null || allOptions === void 0 ? void 0 : allOptions.name : placeholder} returnType={returnType} value={value} onChange={onChange} {...rest}/>
      </SpinnerError>
    </Ripple>);
}
